import React, { isValidElement, useMemo } from 'react';

interface Return {
  interactiveBlocks: React.ReactNode[];
  languages: string[];
}

export const useInteractiveCodeBlocks = (
  children: React.ReactNode,
  codeBlockLanguages?: string[],
): Return => {
  const { interactiveBlocks, languages } = useMemo(() => {
    const defaultState: Return = {
      interactiveBlocks: [],
      languages: [],
    };

    return React.Children.toArray(children)
      .filter(
        child =>
          isValidElement(child) &&
          child.props?.mdxType === 'InteractiveLanguage',
      )
      .reduce((acc: Return, child, index) => {
        if (!isValidElement(child)) return acc;

        return {
          ...acc,
          interactiveBlocks: [...acc.interactiveBlocks, child],
          languages: [
            ...acc.languages,
            codeBlockLanguages && codeBlockLanguages[index]
              ? codeBlockLanguages[index]
              : '',
          ],
        };
      }, defaultState);
  }, [children, codeBlockLanguages]);

  return { interactiveBlocks, languages };
};
